import React from "react"

import RequestProxyNumber from "./Request"

export type ProxyNumberProps = {
  studentId: string
  noNumber: boolean
  proxyNumber?: string
}

const ProxyNumber: React.FC<ProxyNumberProps> = ({
  studentId,
  noNumber,
  proxyNumber,
}) => {
  return (
    <>
      {noNumber ? (
        "No number present"
      ) : proxyNumber ? (
        <a href={`sms:${proxyNumber}`}>{proxyNumber}</a>
      ) : (
        <RequestProxyNumber studentId={studentId} />
      )}
    </>
  )
}

export default ProxyNumber
